class ServerCommunicator {
	static mutualBaseURL = '/api/';
	// Based on the config does a request
	// The object returned is in JSON format and returned as a promise
	static async doRequest(config: Object, extension: string): Promise<any> {
		// console.log('response doRequest',  extension )

		const response = await fetch(this.mutualBaseURL + extension, config);
		if (!response.ok) {
			throw response;
		}
		return await response.json();
	}
}

export default ServerCommunicator;
